// extracted by mini-css-extract-plugin
module.exports = {"ApprovalsCentre":"ApprovalsCentre_ApprovalsCentre__1tyyd","HeaderButtonRow":"ApprovalsCentre_HeaderButtonRow__3I_kW"};